import React from 'react';
import './MessageAddress.css';
import Alert from '../../../../images/alerta.png';
import parse from 'html-react-parser';

const MessageAddress = ({ text, height }) => {
  // Función para convertir el string en JSX válido
  const parseContent = (content) => {
    try {
      // Reemplazar los saltos de línea \r\n por espacios
      content = content.replace(/\r\n/g, ' ');
      // Reemplazar <> y </> por div para que sea HTML válido
      content = content.replace(/<>/, '<div>').replace(/<\/>/, '</div>');
      return parse(content);
    } catch (error) {
      console.error('Error parsing content:', error);
      return content; // Retorna el contenido original si hay error
    }
  };

  return (
    <div>
      <div className="messageAddres" style={{ height: height }}>
        <img className='img-alert' src={Alert} alt="" />
        <div className='message-container-adress'>
          {text ? parseContent(text) : null}
        </div>
      </div>
    </div>
  );
};

export default MessageAddress;
